import React from 'react';

import '../styles/scss/components/layout.scss';

const Footer = () => {
  return (
    <div className="footer-container">
      {/* <img
        src="https://cdn.pixabay.com/photo/2019/03/14/06/37/bread-4054286_960_720.jpg"
        alt="banner"
      /> */}
    </div>
  );
};

export default Footer;
